import { useApiClient } from '../context/AppContext'
import IResourceLoader from '../types/IResourceLoader'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'
import { FetchIncidents, ILoadIncidents } from '../types'
import reportsApi from '../api/reportsApi'
import { IIncidentsData } from '../types/Incidents/IIncidentTypes'

const useIncidents = (): [IResourceLoader<IIncidentsData>, ILoadIncidents] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IIncidentsData>(
    'Unable to load reported accidents'
  )

  const loader = useCallbackRef<FetchIncidents>(
    async (storeCode: string, page: number, type?: string | null): Promise<IIncidentsData> => {
      return resource.load(async () =>
        reportsApi.GetReports(apiClient, storeCode, page, type || null) as Promise<IIncidentsData>
      )
    }
  )

  return [resource, loader]
}

export default useIncidents
